import React from 'react'
import AppBar from '../components/AppBar'
import { useNavigate } from 'react-router-dom'
import Gap from '../components/Gap'
import { REFERRAL_READY } from '../constants/featureFlags'

const Settings: React.FC = () => {
  const navigate = useNavigate()

  const handleAccountManagementClick = () => {
    navigate('/account-management')
  }

  /*
   * 취향분석(BETA). 앱 안 화면이라 그냥 라우팅한다.
   *
   * 예전에는 tastee.kr/quiz 로 내보냈는데, 웹사이트 머리말·꼬리말이 그대로
   * 보여 앱 화면으로 안 읽혔다. 게다가 오리진이 달라 결과가 계정에 붙지도
   * 않았다. 지금은 같은 오리진이라 로그인 토큰이 함께 가고 서버가 user_id 를
   * 적는다. 계정 없는 사람은 여전히 tastee.kr/quiz 를 쓴다.
   */
  const handleTasteQuizClick = () => {
    navigate('/taste-quiz')
  }

  const handleAnnouncementsClick = () => {
    navigate('/notice')
  }

  const handleTermsClick = () => {
    navigate('/consent-management')
  }

  const handleReplayTutorialClick = () => {
    // 홈으로 이동하며 코치마크 재열람 트리거
    navigate('/main-home', { state: { replayTutorial: true } })
  }

  /*
   * 고객센터.
   *
   * 예전에는 바텀시트를 올려 admin@tastee.kr 한 줄을 보여주는 게 전부였다. 메일로
   * 받으면 보낸 사람이 어느 계정인지·어떤 버전을 쓰는지 맞춰 봐야 했고, 답을
   * 보냈는지 사용자는 앱에서 알 수 없었다. 이제 앱 안에서 주고받고 답변은 알림으로 온다.
   *
   * 메일 주소는 없애지 않고 /support/list 맨 아래로 옮겼다 — 로그인이 안 되는
   * 사람에게는 그게 유일한 통로다.
   */
  const handleCustomerServiceClick = () => {
    navigate('/support')
  }

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColorBg2">
      <AppBar title="환경설정" isBottomBorder />

      <div className="app-container flex-1 overflow-y-auto scrollbar-hide">
        <Gap height={8} />

        {/* 계정 관리 */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleAccountManagementClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            계정 관리
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>

        {/*
          친구 초대 — 이미 가입한 사람이 내 추천인 코드를 보고 공유하는 자리.
          코드를 '입력'하는 곳은 아니다(입력은 가입할 때만). 다 될 때까지 REFERRAL_READY 로 가린다.
        */}
        {REFERRAL_READY && (
          <div
            className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
            onClick={() => navigate('/invite')}
          >
            <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
              친구 초대
            </span>
            <Gap width={8} />
            <img
              src="/images/bold-arrow-right-icon.png"
              alt="이동"
              className="w-24px h-24px object-contain"
            />
          </div>
        )}

        {/* 취향분석 (BETA) */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleTasteQuizClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            취향 분석 (BETA)
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>

        {/* 공지사항 */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleAnnouncementsClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            공지사항
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>

        {/* 이용약관 */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleTermsClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            이용약관
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>

        {/* 튜토리얼 */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleReplayTutorialClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            튜토리얼
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>

        {/* 고객센터 */}
        <div
          className="w-full px-20px py-16px flex items-center justify-between cursor-pointer"
          onClick={handleCustomerServiceClick}
        >
          <span className="flex-1 font-pretendard font-bold text-16px leading-180% text-brown-80%-main">
            고객센터
          </span>
          <Gap width={8} />
          <img
            src="/images/bold-arrow-right-icon.png"
            alt="이동"
            className="w-24px h-24px object-contain"
          />
        </div>
      </div>

    </div>
  )
}

export default Settings
